var _style, _path, _defs, _g, _path2, _defs2, _defs3, _defs4, _defs5, _g2, _defs6, _defs7, _defs8, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOnboardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 21.8 17.9",
    style: {
      enableBackground: "new 0 0 21.8 17.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#1D3152;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st1{clip-path:url(#SVGID_2_);}\n\t.st2{fill:#1D3152;}\n\t.st3{clip-path:url(#SVGID_4_);}\n\t.st4{clip-path:url(#SVGID_6_);}\n\t.st5{clip-path:url(#SVGID_8_);}\n\t.st6{clip-path:url(#SVGID_10_);}\n\t.st7{clip-path:url(#SVGID_12_);}\n\t.st8{clip-path:url(#SVGID_14_);}\n\t.st9{clip-path:url(#SVGID_16_);}\n\t.st10{fill:none;stroke:#1D3152;stroke-width:1.8;stroke-miterlimit:10;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.6,12.1c-1.8,0.9-4,0.2-4.9-1.6C7.3,9.7,7.2,8.8,7.4,7.9"
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_1_",
    points: "8.5,8.6 7.8,6.2 6.1,8  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1,
    transform: "matrix(0.2419 -0.9703 0.9703 0.2419 -1.296 12.8585)",
    className: "st2",
    width: 12.1,
    height: 12.4
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.2,5.6c1.8-1,4-0.3,4.9,1.5c0.4,0.8,0.6,1.7,0.3,2.6"
  })), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_3_",
    x: 13.3,
    y: 9.2,
    transform: "matrix(0.2419 -0.9703 0.9703 0.2419 0.7884 21.7618)",
    width: 2.1,
    height: 2.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_5_",
    x: 13.4,
    y: 8.7,
    width: 3,
    height: 3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_6_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_5_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_7_",
    points: "13.4,9.1 14.1,11.4 15.8,9.6  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_8_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_7_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_9_",
    x: 12.4,
    y: 8.7,
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_10_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_9_",
    style: {
      overflow: "visible"
    }
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st6"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8.3,
    y: 4.2,
    transform: "matrix(0.2419 -0.9703 0.9703 0.2419 0.7959 21.7715)",
    className: "st2",
    width: 12.1,
    height: 12.4
  }))))))))))), /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_11_",
    d: "M6.4,1.7h9c1.7,0,3,1.3,3,3v8.5c0,1.7-1.3,3-3,3h-9c-1.7,0-3-1.3-3-3V4.7C3.4,3,4.7,1.7,6.4,1.7z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_12_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_11_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st7"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_13_",
    x: -6.6,
    y: -7.3,
    width: 34,
    height: 33
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_14_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_13_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("g", null, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_15_",
    x: 3.4,
    y: 1.7,
    width: 15,
    height: 15
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_16_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_15_",
    style: {
      overflow: "visible"
    }
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M6.4,1.7h9c1.7,0,3,1.3,3,3v8.5c0,1.7-1.3,3-3,3h-9c-1.7,0-3-1.3-3-3V4.7C3.4,3,4.7,1.7,6.4,1.7z"
  }))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnboardIcon);
export default __webpack_public_path__ + "static/media/onboard-icon.ec449aa5592142aec3ea7647a3aef671.svg";
export { ForwardRef as ReactComponent };